import { initComboAlumno } from "../combo_alumno"
import { initToasts } from "../toasts"
import { initContadorPalabras } from "../contador_palabras"
import { initConfirmaciones } from "../confirmar"
import { initAvisoAbajo } from "../aviso_abajo"

// Vanilla JS progresivo (sin framework).
function init() {
  initComboAlumno()
  initToasts()
  initContadorPalabras()
  initConfirmaciones()
  initAvisoAbajo()
}

if (document.readyState !== "loading") {
  init()
} else {
  document.addEventListener("DOMContentLoaded", init)
}
